module.exports = __webpack_public_path__ + "static/media/grainger.8a397bc2.png";